var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 27.178V7.2C8 6.53726 8.53726 6 9.2 6H26.8C27.4627 6 28 6.53726 28 7.2V27.178C28 28.2363 26.7297 28.7765 25.9675 28.0423L18.8325 21.1697C18.3678 20.7221 17.6322 20.7221 17.1675 21.1697L10.0325 28.0423C9.27028 28.7765 8 28.2363 8 27.178Z",
    fill: "#505050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkIcon);
export default __webpack_public_path__ + "static/media/bookmark_icon.22511d0a33b422ce63af030882fec586.svg";
export { ForwardRef as ReactComponent };